import { DECLARATION_STATUT_OPTIONS } from '@common/config';
import { SetUtils } from '@common/utils';
import React from 'react';
import { DropdownSelectionFilter } from '../DropdownSelectionFilter';

export const StatutDeclarationFilter = ({ statut, onStatutChange }: StatutDeclarationFilterProps) => {
  return (
    <DropdownSelectionFilter selection={new Set((statut) ? [statut] : [])}
                             onSelectionChange={(selection) => onStatutChange(SetUtils.takeFirst(selection))}
                             buttonLabel="statut de la déclaration"
                             options={DECLARATION_STATUT_OPTIONS}
                             tooltip="Filtrer par statut de la déclaration" />
  );
};

interface StatutDeclarationFilterProps {
  statut: string | null;
  onStatutChange: (statut: string) => void;
}